import React from "react";
import PopoverMenu from "PopoverMenu";

const SettingsAndProfileMenu = (isMember) => {
  const linkData = {
    settings: {
      title: 'Settings',
      show: isMember,
      link: "/account-settings",
    },
    terms: {
      title: 'Terms',
      show: true,
      target: '_blank',
      rel: 'noreferrer',
      link: "https://sanabenefits.com/terms-of-service",
    },
    privacy: {
      title: 'Privacy',
      show: true,
      target: '_blank',
      rel: 'noreferrer',
      link: "https://sanabenefits.com/privacy-policy",
    },
    logout: {
      title: 'Log out',
      show: true,
      link: "/logout",
    },
  };

  return (
    <PopoverMenu linkData={linkData} bottom="32px" left="173px" />
  );
}

export default SettingsAndProfileMenu;
